import axios from 'axios';
let sendMessage = function(message)
{
    let data = {
        chat_id: '-1001379938996',
        text: message,
        parse_mode: 'HTML',
    };
    axios.post('https://api.telegram.org/bot1308629483:AAGrLmm1iZzY8vDfD6rJ4o695l_o_KvgQRg/sendMessage', data);
}

export default sendMessage;